import React from 'react';
import { Box } from '@chakra-ui/react';
import dynamic from 'next/dynamic';
import { INewsletterData } from '@/constants/pages/newsletter';


const NoSSRComponent = dynamic(() => import('./NoSSRComponent'), {
  ssr: false,
});


const NewsletterDetailsLayout: React.FC<{
  newsletterData?: INewsletterData;
}> = ({ newsletterData }) => (
  <Box position="relative">
    <NoSSRComponent NewsletterData={newsletterData} />
  </Box>
);

export default NewsletterDetailsLayout;
